<template>
  <div class="sidebar-inner">
    <!-- Top section -->
    <div class="top-section">
      <div v-if="!isLoadingAxumData">
        <div class="d-flex">
          <div class="flex-grow-1">
            <h4 class="mb-1">AXUM</h4>
          </div>
          <div class="flex-shrink-1" v-if="ticket.axum_booking_id">
            <span class="badge font-size-14 badge-primary" v-if="isFIT">FIT</span>
            <span class="badge font-size-14 badge-primary" v-if="isSGT">SGT</span>
          </div>
        </div>
      </div>
      <h4 v-if="isLoadingAxumData" class="mb-1">Loading AXUM Data...</h4>
      <hr>
      <!-- Is Loading -->
      <div class="text-center mt-4" v-if="isLoadingAxumData">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>
      <!-- / Is Loading -->

      <!-- Loaded -->
      <div v-if="!isLoadingAxumData && axumData !== null">
        <div class="property-card">
          <b class="property-name">AXUM Booking ID</b>
          <div class="mt-1">
            {{ ticket.axum_booking_id ? ticket.axum_booking_id : 'Not Provided' }}
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Booking Title
          </b>
          <div class="mt-1">
                         <span v-if="axumData.bookingTitle">
                            {{ axumData.bookingTitle }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Consultant
          </b>
          <div class="mt-1">
                        <span v-if="axumData.consultant">
                            {{ axumData.consultant.username }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Consultant Branch
          </b>
          <div class="mt-1">
                        <span v-if="axumData.consultant && axumData.consultant.branch && axumData.consultant.branch.formalName">
                            {{ axumData.consultant.branch.formalName }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Travel Agent
          </b>
          <div class="mt-1">
                        <span v-if="axumData.ownerName">
                            {{ axumData.ownerName }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Admin
          </b>
          <div class="mt-1">
            <div v-if="axumData.admin">
              {{ axumData.admin.username }} <span
                v-if="axumData.admin.jobTitle">({{ axumData.admin.jobTitle }})</span>
            </div>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Departure Date
          </b>
          <div class="mt-1">
                        <span v-if="axumData.departureDate">
                            {{ formatDate(axumData.departureDate) }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Return Date
          </b>
          <div class="mt-1">
                        <span v-if="axumData.returnDate">
                            {{ formatDate(axumData.returnDate) }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name">
            Lead Pax
          </b>
          <div class="mt-1">
                        <span v-if="leadPax">
                            {{ leadPax.firstname }} {{ leadPax.surname }}
                        </span>
            <span v-else>-</span>
          </div>
        </div>

        <pax-affected class="mt-3"></pax-affected>

        <div class="axum-data mt-3" v-if="axumData.length == 0">
          <div class="property-card">
            <b class="property-name text-danger">
              No data for this Booking ID
            </b>
          </div>
        </div>
      </div>
      <!-- / Loaded -->
    </div>
    <!-- / Top section -->
    <!-- Bottom section -->
    <div class="bottom-section pt-3 pb-3">
      <itinerary-button-and-modal></itinerary-button-and-modal>

      <!--            <a href="#" @click.prevent="refresh" class="btn btn-itg-dark btn-block"-->
      <!--               :class="{'disabled': isLoadingAxumData}">-->
      <!--                <i class="fa fa-sync mr-1"></i>-->
      <!--                Refresh-->
      <!--            </a>-->
    </div>
    <!-- / Bottom section -->
  </div>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import Tickets from "../../../../../mixins/Tickets";
import Dates from "../../../../../mixins/Dates";
import PaxAffected from "./Axum/PaxAffected";
import ItineraryButtonAndModal from "./Axum/ItineraryButtonAndModal";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "AxumSidebar",
  mixins: [Forms, Tickets, Dates],
  data() {
    return {}
  },
  created() {
    this.loadAxumData();
  },
  components: {PaxAffected, ItineraryButtonAndModal},
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      isLoadingAxumData: 'isLoadingAxumData',
      axumData: 'axumData'
    }),

    isFIT() {
      if (this.ticket.axum_booking_id && !isNaN(this.ticket.axum_booking_id)) {
        return Number(this.ticket.axum_booking_id) < 2000000;
      }
      return false;
    },

    isSGT() {
      if (this.ticket.axum_booking_id && !isNaN(this.ticket.axum_booking_id)) {
        return Number(this.ticket.axum_booking_id) >= 2000000;
      }
      return false;
    },

    leadPax() {
      if (this.axumData.leadPassengerId) {
        return _.first(this.axumData.passengers, {
          passengerId: this.axumData.leadPassengerId
        });
      }
      return null;
    }
  },
  methods: {
    ...mapActions('ticketViewer', {
      loadAxumData: 'loadAxumData'
    }),

    refresh() {
      if (this.isLoadingAxumData) {
        return false;
      }
      this.loadAxumData();
    }
  }
}
</script>

<style scoped lang="scss">
.property-card {
  background: #fff;
  border-radius: 5px;
  padding: 15px;

  .property-name {
    font-weight: 600;
    color: #2c5cc5;
  }
}
</style>
